<template>
  <div v-if="!loading">
    <v-container
      v-if="detail !== null"
      style="
        padding: 0 0 20px 0;
        margin: auto;
        border-radius: 5px;
        background: white;
      "
    >
      <v-form
        ref="entryForm"
        @submit.prevent="submit()"
        lazy-validation
        :disabled="loading"
      >
        <v-card
          tile
          flat
          style="
            border-bottom: 2px solid rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            position: sticky;
            top: 60px;
            background: white;
            z-index: 5;
          "
        >
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 10px;
            "
          >
            <v-toolbar-title class="overline" style="position: relative">
              <p
                :style="`font-size:${
                  wWidth > 780 ? '20px' : '3vw'
                }; margin: 0;`"
              >
                Detail Project
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDetail"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </p>
            </v-toolbar-title>
          </div>
          <div class="actionButton">
            <div
              v-if="
                (detail.status == 1 &&
                  (detail.employee_id == getUserProfile.employee.id ||
                    getUserProfile.level.find(({ id }) => id == '1') !=
                      undefined)) ||
                getUserProfile.employee.email == 'procurement@sanqua.co.id'
              "
            >
              <v-btn
                @click="doneProject"
                rounded
                elevation="0"
                color="success"
                class="white--text font-weight-bold ma-2"
                style="font-size: 12px"
                :loading="loading"
              >
                Done
              </v-btn>
            </div>
            <div
              v-if="
                (detail.status == 3 &&
                  (detail.employee_id == getUserProfile.employee.id ||
                    getUserProfile.level.find(({ id }) => id == '1') !=
                      undefined)) ||
                getUserProfile.employee.email == 'procurement@sanqua.co.id'
              "
            >
              <v-btn
                @click="setDraftProject"
                rounded
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-2"
                style="font-size: 12px"
                :loading="loading"
              >
                Set Draft
              </v-btn>
            </div>
            <div
              v-if="
                detail.status == 0 &&
                (detail.employee_id == getUserProfile.employee.id ||
                  getUserProfile.level.find(({ id }) => id == '1') != undefined)
              "
            >
              <v-btn
                @click="submitProject"
                rounded
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-2"
                style="font-size: 12px"
                :loading="loading"
              >
                Submit
              </v-btn>
            </div>
            <!-- Cancel button -->
            <div
              v-if="
                (detail.status == 0 || detail.status == 1) &&
                (detail.employee_id == getUserProfile.employee.id ||
                  getUserProfile.level.find(({ id }) => id == '1') != undefined)
              "
            >
              <v-dialog v-model="cancelDialog" width="500" persistent>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    type="button"
                    rounded
                    elevation="0"
                    color="red"
                    class="white--text font-weight-bold ma-2"
                    style="font-size: 12px"
                    :loading="loading"
                  >
                    Cancel
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title class="text-h5 grey lighten-2">
                    Form Pembatalan
                  </v-card-title>

                  <v-card-text class="d-flex justify-center align-center">
                    <v-col
                      md="12"
                      style="padding: 0; position: relative; top: 20px"
                    >
                      <div style="padding: 0 10px">
                        <v-col cols="12" style="padding: 0">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Alasan pembatalan
                          </p>
                        </v-col>
                        <v-col cols="12" style="padding: 0">
                          <v-textarea v-model="form.cancel_reason" outlined />
                        </v-col>
                      </div>
                    </v-col>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn
                      color="error"
                      text
                      outlined
                      @click="
                        () => {
                          ;(cancelDialog = false), (form.cancel_reason = null)
                        }
                      "
                      :loading="loading"
                    >
                      Tutup
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click.prevent="cancelProject()"
                      color="primary"
                      type="button"
                      text
                      outlined
                      :loading="loading"
                    >
                      Batalkan Project
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <v-btn
              type="button"
              rounded
              elevation="0"
              color="black"
              class="black--text font-weight-bold ma-2"
              style="font-size: 12px"
              @click.prevent="close"
              :loading="loading"
              outlined
            >
              <v-icon small>mdi-chevron-left</v-icon>
              Kembali
            </v-btn>
          </div>
        </v-card>

        <v-card elevation="0">
          <div style="padding: 0; text-align: center; height: 30px">
            <!-- <p
              v-if="detail.request_no !== null"
              style="font-size: 20px; margin: 0; font-weight: bold; color:indigo;position:relative;"
            >
              {{ detail.request_no }}
            </p> -->

            <div
              style="position: absolute; left: 10px; top: -21px; display: flex"
            >
              <p style="font-size: 11px; margin: 0">
                <span>
                  Dibuat : {{ detail.created_at }} ({{
                    detail.created_by_name
                  }})
                </span>
                |
                <span>
                  Update : {{ detail.updated_at }} ({{
                    detail.updated_by_name
                  }})
                </span>
                <span v-if="detail.status == 3">
                  | Cancel : {{ detail.cancel_at }} ({{
                    detail.cancel_by_name
                  }})
                </span>
                <span v-if="detail.status == 2">
                  | Done : {{ detail.done_at }} ({{ detail.done_by_name }})
                </span>
              </p>
            </div>

            <div style="position: absolute; right: 10px; top: 5px">
              <v-btn
                v-if="detail.status === 0"
                @click.prevent="edit()"
                type="button"
                text
                icon
                elevation="0"
                color="primary"
                class="white--text font-weight-bold"
                style="font-size: 12px"
                :loading="loading"
              >
                <v-icon small>mdi-pencil</v-icon>
                Edit
              </v-btn>
            </div>
          </div>
          <v-row style="padding: 15px" no-gutters>
            <v-col cols="12" md="4" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Project
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 6px">
                  <v-text-field outlined dense :value="detail.name" readonly />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="4" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kode Project
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 4px">
                  <v-text-field
                    dense
                    :value="detail.odoo_project_code"
                    readonly
                    outlined
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="4" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Status
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 6.5px">
                  <v-text-field
                    outlined
                    dense
                    :value="status(detail.status)"
                    readonly
                  />
                </v-col>
              </div>
            </v-col>

            <v-col cols="12" md="4" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Penanggung Jawab
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 6px">
                  <v-text-field
                    outlined
                    dense
                    :value="detail.employee_name"
                    readonly
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" md="4" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 4px">
                  <v-text-field
                    outlined
                    dense
                    :value="detail.company_name"
                    readonly
                  />
                </v-col>
              </div>
            </v-col>
            <v-col cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan Tambahan
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 4px">
                  <v-textarea
                    auto-grow
                    :rows="2"
                    outlined
                    dense
                    :value="detail.description"
                    readonly
                  />
                </v-col>
              </div>
            </v-col>
            <v-col v-if="detail.status == 3" cols="12" style="padding: 0">
              <div style="padding: 0 10px">
                <v-col cols="12" style="padding: 0">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Alasan Cancel
                  </p>
                </v-col>
                <v-col cols="12" style="padding: 0; margin-top: 4px">
                  <v-textarea
                    auto-grow
                    :rows="2"
                    outlined
                    dense
                    :value="detail.cancel_reason"
                    readonly
                  />
                </v-col>
              </div>
            </v-col>

            <v-col cols="12" style="padding: 10px">
              <div
                class="d-flex"
                style="
                  color: #4e4e4e;
                  margin-left: 5px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  border-bottom: 1px solid #a1a1a1;
                "
              >
                RAB LIST
                <!-- <router-link to="/e-catalogue/rab/submission"> -->
                <v-btn
                  v-if="detail.status == 1"
                  @click="openFormRab"
                  elevation="1"
                  color="primary"
                  type="button"
                  small
                  class="white--text font-weight-bold"
                  style="margin: 0; position: relative; left: 10px; bottom: 4px"
                  :loading="loading"
                >
                  + Buat RAB
                </v-btn>
                <!-- </router-link> -->
              </div>
              <v-data-table
                :headers="rabHeaders"
                @click:row="openDetailRab"
                :items="rabResult"
                :items-per-page="10"
                hide-default-footer
                mobile-breakpoint="0"
                class="elevation-1 mx-auto"
                style="cursor: pointer; border: 1px solid rgba(0, 0, 0, 0.2)"
              >
                <template v-slot:[`item.budget_no`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.budget_no }}
                  </div>
                </template>
                <template v-slot:[`item.name`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:[`item.company`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.company.name }}
                  </div>
                </template>
                <template v-slot:[`item.pic_employee`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.employee.name }}
                  </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <td :style="`color:${statusColor(item.status.id)}`">
                    {{ item.status.name }}
                  </td>
                </template>
                <template v-slot:[`item.total_budget_plan`]="{ item }">
                  <div :style="`font-size:14px; width:80px; padding: 0;`">
                    {{ priceConvert(item.total_budget_plan) }}
                  </div>
                </template>
                <template v-slot:[`item.department`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.department.name }}
                  </div>
                </template>
                <template v-slot:[`item.project`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.project.name }}
                  </div>
                </template>
                <template v-slot:[`item.submited_at`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.submited_at }}
                  </div>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  <div style="width: 120px; font-size: 12px">
                    {{ item.created_at }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-form>
      <div
        v-if="detail.status == 1"
        class="d-flex flex-column justify-center align-start mt-10"
        style="padding: 0 25px; width: 100%"
      >
        <router-link style="width: 100%" to="/e-catalogue/catalogue-list">
          <v-btn
            elevation="1"
            color="primary"
            type="submit"
            class="white--text font-weight-bold mb-5"
            style="font-size: 14px; width: 100%"
            :loading="loading"
          >
            BUAT FPB BARU
          </v-btn>
        </router-link>
      </div>
    </v-container>
    <div
      v-else
      class="d-flex justify-center align-center"
      style="width: 100%; height: 80vh; position: relative"
    >
      <div>
        <v-btn
          type="button"
          rounded
          elevation="0"
          color="red"
          class="white--text font-weight-bold ma-2"
          style="font-size: 12px; position: absolute; top: 10px; left: 10px"
          @click.prevent="close"
          :loading="loading"
          outlined
        >
          <v-icon small>mdi-chevron-left</v-icon>
          Kembali
        </v-btn>
      </div>
      <p style="color: RGBA(0, 0, 0, 0.5); font-size: 24px; font-weight: bold">
        DATA NOT FOUND
      </p>
    </div>
  </div>
  <div v-else class="d-flex justify-center align-center" style="height: 100%">
    <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  name: 'projectdetail',
  components: {},
  data() {
    return {
      hrsApi: buildType.apiURL('hrs'),
      eSanqua: buildType.apiURL('esanqua'),
      proc: buildType.apiURL('proc'),
      build: process.env.VUE_APP_BUILD_TYPE,
      wWidth: window.innerWidth,
      dialog: false,
      cancelDialog: false,
      loading: false,
      detail: null,
      rabHeaders: [
        {
          text: 'Project',
          value: 'project',
          align: 'left',
          sortable: false
        },
        {
          text: 'No. RAB',
          value: 'budget_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Nama',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Unit/Plant',
          value: 'company',
          align: 'left',
          sortable: false
        },
        {
          text: 'Department',
          value: 'department',
          align: 'left',
          sortable: false
        },
        {
          text: 'Penanggung Jawab',
          value: 'pic_employee',
          align: 'left',
          sortable: false
        },
        {
          text: 'Total Budget',
          value: 'total_budget_plan',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Buat',
          value: 'created_at',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Submit',
          value: 'submited_at',
          align: 'left',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        }
      ],
      rabResult: [],
      form: {
        cancel_reason: null
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  async mounted() {
    this.loading = true
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    await this.getDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    ...mapMutations(['setProjectDetail']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    openFormRab() {
      this.setProjectDetail(this.detail)
      setTimeout(() => {
        this.$router.push('/e-catalogue/rab/submission')
      }, 200)
    },
    async getListRab() {
      this.fpbResult = []
      let url = `${this.proc}rab/list?keyword=&offset=0&limit=10&company_id=${this.detail.company_id}`
      const filter = []
      filter.push(`{"project_id":"${this.$route.params.id}"}`)
      url = url + `&filter=[${filter}]`

      await axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.rabResult = res.data.data
            console.log('rabResult>>>', res)
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog('error', err.msg, false)
        })
    },
    openDetailRab(pValue, pSlot) {
      setTimeout(() => {
        this.$router.push(
          `/e-catalogue/rab/detail/${pValue.id}?idx=${pSlot.index}`
        )
      }, 200)
    },
    async getDetail() {
      this.loading = TextTrackCueList
      const url = `${this.proc}project/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('project/detail/>>>', res, this.getUserProfile)
          if (res.data.status_code !== '-99') {
            // res.data.data.
            this.detail = res.data.data
            this.getListRab()
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          return (this.loading = false)
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
          return (this.loading = false)
        })
    },
    onResize() {
      this.wWidth = window.innerWidth
    },
    close() {
      if (this.detail !== null) {
        this.$refs.entryForm.reset()
      }
      if (this.prevRoute !== undefined) {
        if (this.prevRoute.path !== '/e-catalogue/project/submission') {
          this.$router.push(this.prevRoute.path)
        } else {
          this.$router.push('/e-catalogue/project')
        }
      } else {
        this.$router.push('/e-catalogue/project')
      }
    },
    async submitProject() {
      this.showMsgDialog('question', 'Submit project sekarang ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            await axios
              .post(`${this.proc}project/submit`, {
                id: this.$route.params.id
              })
              .then((res) => {
                console.log(res)
                this.loading = false
                if (res.data.status_code !== '-99') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDetail()
                } else {
                  if (res.data.status_msg === 'Parameter value has problem') {
                    this.showMsgDialog(
                      'error',
                      'Invalid input, Parameter value has problem',
                      false
                    )
                  } else {
                    this.showMsgDialog('error', res.data.status_msg, false)
                  }
                }
                return null
              })
              .catch((err) => {
                console.log(err)
                this.showMsgDialog(
                  'error',
                  err
                    ? 'Something went wrong, Please contact an admin!'
                    : 'Something went wrong, Please contact an admin!',
                  false
                )
                this.loading = false
                return null
              })
          }
        }
      )
    },
    async cancelProject() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin cancel project ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .post(`${this.proc}project/cancel`, {
              id: this.$route.params.id,
              cancel_reason: this.form.cancel_reason
            })
            .then((res) => {
              this.loading = false
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
                this.cancelDialog = false
                this.form.cancel_reason = null
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'error',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('error', res.data.status_msg, false)
                }
              }
              return null
            })
            .catch((err) => {
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
              this.loading = false
              return null
            })
        }
      })
    },
    async setDraftProject() {
      this.showMsgDialog(
        'question',
        'Kembalikan status menjadi draft sekarang ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .post(`${this.proc}project/set_draft`, {
              id: this.$route.params.id
            })
            .then((res) => {
              this.loading = false
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'error',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('error', res.data.status_msg, false)
                }
              }
              return null
            })
            .catch((err) => {
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
              this.loading = false
              return null
            })
        }
      })
    },
    async doneProject() {
      this.showMsgDialog(
        'warning',
        'Project yang sudah done akan terkunci dan tidak bisa digunakan lagi, anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .post(`${this.proc}project/done`, {
              id: this.$route.params.id
            })
            .then((res) => {
              this.loading = false
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDetail()
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'error',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('error', res.data.status_msg, false)
                }
              }
              return null
            })
            .catch((err) => {
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
              this.loading = false
              return null
            })
        }
      })
    },
    edit() {
      this.setProjectDetail(this.detail)
      setTimeout(() => {
        this.$router.push('/e-catalogue/project/submission')
      }, 300)
    },
    priceConvert(xVal) {
      const num = 0
      if (xVal !== undefined) {
        if (xVal !== null) {
          let round = xVal
          if (round.toString().includes('.')) {
            round = round.toFixed(2)
          }
          const val = round + ''
          let result = ''

          if (val.includes('.')) {
            const splitVal = val.split('.')
            const main = splitVal[0]
            const decimal = splitVal[1]
            result =
              main.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',') +
              `.${decimal}`
          } else {
            result = val
              .toString()
              .replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, ',')
          }
          return result
        }
      }
      return num
    },
    status(val) {
      switch (val) {
        case 0:
          return 'Draft'
        case 1:
          return 'Submited'
        case 2:
          return 'Done'
        case 3:
          return 'Cancel'
      }
    },
    statusColor(val) {
      switch (val) {
        case 0:
          return 'color: #black; background-color: #4e4e4e1f;'
        case 1:
          return 'color: rgb(138, 90, 0); background-color: rgba(255, 166, 0, 0.3);'
        case 2:
          return 'color: green; background-color: #4e4e4e1f;'
        case 3:
          return 'color: red; background-color: #4e4e4e1f;'
        default:
          return 'black'
      }
    }
  }
}
</script>
<style lang="scss">
.actionButton {
  position: relative;
  display: flex;
  // width: 400px;
}
.approvalMatrix {
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
}
@media (max-width: 766px) {
  .actionButton {
    justify-content: center;
    align-items: flex-start;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
  }
  .approvalMatrix {
    margin-bottom: 50px;
  }
}
</style>
